import { Directive, HostListener } from '@angular/core';


/**------------------------------------------------------
 * Prevent Click Propagation
 * -------------------------
 * Prevent click propagation and default.
 *
 * Theoretical Example:
 * If we need to prevent the closing dropdown on click of
 * dropdown menu then then directive is useful.
 *
 * Example:
 * --------
 * 	<i aria-hidden='true' class='fas fa-info-circle' ngPreventClickPropagation>
 */
@Directive({
    selector: '[ngPreventClickPropagation]',
    standalone: false
})
export class NgPreventClickPropagationDirective {

	// click stop propagation
	@HostListener('click', ['$event'])
	public onClick(event: MouseEvent): void {
		event.stopImmediatePropagation();
		event.preventDefault();
	}
}
